import { Record } from 'immutable';

export default class InvoiceDetailRecord extends Record({
  id: undefined,
  description: undefined,
  quantity: undefined,
  sort: undefined,
  total: undefined,
  totalIncVat: undefined,
  unit: undefined,
  unitPrice: undefined,
  vat: undefined,
  vatRate: undefined,
  articleNumber: undefined,
  articleName: undefined,
}) {}
